module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/8-288fe0bbcd80cd5e1e3a18a4cf9127e2.jpg";